import React, { useState } from 'react';
import { Form } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import Swal from 'sweetalert2';
import { ProfileFormComponent } from './ProfileFormComponent';
import { logisticsClient } from '../../../../../core-module/services/logistics/LogisticsClient';
import { CamasysCustomer } from '../../../../../core-module/services/logistics/types';

interface OwnProps {
  readonly customerId: number;
  readonly camasysCustomer: CamasysCustomer;
  readonly onHideClick: () => void;
}

interface FormValues {
  route_remarks: string;
  meal_overview_amount: number;
  default_portion?: number;
}

type Props = OwnProps & FormComponentProps<FormValues>;

const ProfileFormContainer: React.FC<Props> = ({
  form,
  customerId,
  camasysCustomer,
  onHideClick
}) => {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = () => {
    form.validateFields(
      ['route_remarks', 'meal_overview_amount', 'default_portion'],
      (errors, values) => {
        if (!errors) {
          setIsSaving(true);

          logisticsClient
            .updateProfile(customerId, values)
            .then(() => {
              Swal({
                type: 'success',
                confirmButtonText: 'Ok',
                title: 'Gegevens opgeslagen',
                text: 'De gegevens zijn succesvol opgeslagen'
              });
              onHideClick();
            })
            .catch((err) => {
              Swal({
                type: 'error',
                confirmButtonText: 'Ok',
                title: 'Er is een fout opgetreden',
                text: err.message
              });
            })
            .finally(() => {
              setIsSaving(false);
            });
        }
      }
    );
  };

  return (
    <ProfileFormComponent
      form={form}
      camasysCustomer={camasysCustomer}
      isSaving={isSaving}
      onSaveClick={handleSave}
      onHideClick={onHideClick}
    />
  );
};

export default Form.create<Props>()(ProfileFormContainer);
